<template>
	<b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" :title="title" :size="modalSize" class="modal-primary" @hidden="clearModalData">
		<CRow>
			<CCol>
				<CTextarea
					label="Komentar"
					v-model="spOrderComment.content"
					rows="5"/>
			</CCol>
		</CRow>
		<CAlert v-show="message.text != null" :color="message.type">
			{{ message.text }}
		</CAlert>
		<template slot="modal-footer" slot-scope="{ cancel }">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="cancel()">Prekliči</b-button>
						<b-button :disabled="okButton.disabled" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
		<vue-loading :active.sync="isLoading" :is-full-page="false"/>
	</b-modal>
</template>

<script>
import { SP_ORDER_COMMENT_CREATE } from "@/store/actions/spOrderComments";


export default {
	name: 'sp-order-comment-create',
	components: {
	},
	methods: {
		showModal: function (modalInput) {
			this.title = 'Dodajanje komentarja';
			this.okButton.label = 'Dodaj';
			this.spOrderComment.sp_order_id = modalInput.spOrderId;
			this.$refs.modal.show();
		},
		clearModalData: function () {
			this.resetSpOrderCommentObject();
			this.title = '';
			this.okButton = {
				label: 'Shrani',
				progress: false,
				disabled: false
			};
			this.showAlert();
		},
		resetSpOrderCommentObject: function () {
			this.spOrderComment.id = null;
			this.spOrderComment.sp_order_id = null;
			this.spOrderComment.content = null;
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		onOkModal: function () {
			if (this.spOrderComment.content.length < 1) {
				this.showAlert('Komentar ne sme biti prazen', this.ALERT_TYPE_ERROR);
				return;
			}
			this.startProgress();
			this.$store.dispatch(SP_ORDER_COMMENT_CREATE, { spOrderComment: this.spOrderComment })
				.then((responseData) => {
					this.stopProgress();
					this.$refs.modal.hide();
					this.$emit('emit_spOrderCommentCreate', responseData);
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri dodajanju komentarja! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		}
	},
	data: function () {
		return {
			isLoading: false,
			title: '',
			okButton: {
				label: 'Shrani',
				progress: false,
				disabled: false,
				title: ''
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			spOrderComment: {
				id: null,
				sp_order_id: null,
				content: null
			}
		}
	},
	watch: {
	},
	computed: {
		modalSize () {
			return 'md';
		},
		uploadPlaceholder () {
			return PH_TEXT;
		},
		acceptedFormats () {
			return '.pdf, .jpg, .jpeg, .png';
		},
		okButtonDisabled () {
			if (this.tmpOrderAttachments.length < 1) {
				this.okButton.title = 'Dodana mora biti vsaj ena datoteka';
				return true;
			}
			this.okButton.title = '';
			return false;
		}
	},
	created () {
	}
}
</script>

<style>
</style>
<style scoped>
.ma_pos {
	text-align: end;
}
</style>